module.exports = __webpack_public_path__ + "img/325.ddfcc324.png";